import React from "react";
import { Layout } from "src/components/layout/Layout";
import { ModuleRouter } from "src/components/molecules";
import { WereHouseRoute } from "./were-house.routes";

export function WereHouse() {
  return (
    <Layout>
      {WereHouseRoute.subRoutes && (
        <ModuleRouter subRoutes={WereHouseRoute.subRoutes} path={WereHouseRoute.path} />
      )}
    </Layout>
  );
}
